module.exports = __webpack_public_path__ + "static/media/may.e4e6aa08.png";